import { Button, Drawer, Form, Input, message, Popover, Space } from "antd";
import moment from "moment";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { RiFilterOffLine, RiMailSendLine } from "react-icons/ri";
import { useSendEmailMutation } from "../../../store/endpoints/email/email";
import formatMoney from "../../../utils/formatMoney";
import formatShort from "../../../utils/formatShort";
import getExpenseByCenter from "../../../utils/getExpenseByCenter";
import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
  sendEmail,
} from "../../../utils/XLSXExport";
const { Search } = Input;
export default function MonthlyPanel({
  isVisible,
  setVisible,
  selected,
  year,
  details,
}: any) {
  const [emailForm] = Form.useForm();
  const [form] = Form.useForm();
  const [messageModal, toggleMessageModal] = useState(false);
  const [sendEmail, emailResult] = useSendEmailMutation();
  const [search, setSearch] = useState("");

  const sendMail = async (values: any) => {
    const data = selected?.list?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Date: moment(record?.posting_date.toString()).format("Do MMM YYYY"),
        Description: record?.description ? record?.description : "-",

        Narrative: record?.narrative ? record?.narrative : "-",
        Department: record?.department ? record?.department : "-",
        "Cost Center": record?.cost_center ? record?.cost_center : "-",
        Origin: record?.origin ? record?.origin : "-",
        Shortname: record?.shortname ? record?.shortname : "-",
        "Expense Code": record?.expense_code ? record?.expense_code : "-",
        "Journal Reference": record?.journal_reference
          ? record?.journal_reference
          : "-",
        Amount: record?.base_value ? record?.base_value : "-",
      };
    });

    const raw = getExportData(data);
    const uri = await blobToDataUrl(raw);

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri,
    });

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const total = selected?.list?.reduce(
    function (accumulator: any, curValue: any) {
      return accumulator + Number(curValue?.base_value);
    },

    0
  );
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            <span className="font-bold mr-2">Computer Running Costs :</span>
            <span>[ {details?.title} ]</span>
          </span>
          {details?.month}
        </div>
      }
      placement={"right"}
      width={1000}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by description"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex flex-row">
            <Popover
              content={
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    form={emailForm}
                    onFinish={sendMail}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[{ required: true, message: "Email is Required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                      label="Subject"
                      name="subject"
                      rules={[
                        { required: true, message: "Subject is Required" },
                      ]}
                    >
                      <Input placeholder="Email Subject" />
                    </Form.Item>
                    <div className="flex flex-row justify-between">
                      <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                        <Button
                          onClick={() => {
                            toggleMessageModal(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </>
              }
              title="Message Content"
              trigger="focus"
              placement="left"
              visible={messageModal}
            >
              <button className="flex ml-4 justify-center items-center border p-1 px-3 hover:bg-green-100">
                <RiMailSendLine size={21} />
                <span
                  className="ml-2"
                  onClick={async () => {
                    toggleMessageModal(true);
                  }}
                >
                  Send Email
                </span>
              </button>
            </Popover>
            <button
              color="#E50000"
              className="flex ml-4 justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={async () => {
                  const data = selected?.list?.map(
                    (record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        Date: moment(record?.posting_date.toString()).format(
                          "Do MMM YYYY"
                        ),
                        Description: record?.description
                          ? record?.description
                          : "-",

                        Narrative: record?.narrative ? record?.narrative : "-",
                        Department: record?.department
                          ? record?.department
                          : "-",
                        "Cost Center": record?.cost_center
                          ? record?.cost_center
                          : "-",
                        Origin: record?.origin ? record?.origin : "-",
                        Shortname: record?.shortname ? record?.shortname : "-",
                        "Expense Code": record?.expense_code
                          ? record?.expense_code
                          : "-",
                        "Journal Reference": record?.journal_reference
                          ? record?.journal_reference
                          : "-",
                        Amount: record?.base_value ? record?.base_value : "-",
                      };
                    }
                  );
                  ExportToExcel(data, "Expenses.xlsx");
                }}
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-28 font-bold">Date</div>
              <div className="w-64 truncate text-left font-bold">
                Description
              </div>
              <div className="w-64 truncate text-left font-bold">Narrative</div>
              <div className="w-20 truncate font-bold">Dept</div>
            </div>
            <div className="font-bold">Amount</div>
          </div>
        </div>
        {selected?.list
          ?.filter((expense: any) => expense?.description?.includes(search))
          ?.map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-28">
                    {moment(item?.posting_date.toString()).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="w-64 truncate text-left">
                    {item?.description}
                  </div>
                  <div className="w-64 truncate text-left">
                    {item?.narrative}
                  </div>
                  <div className="w-20 truncate">
                    {item.department === " " ? "-" : item.department}
                  </div>
                </div>
                <div className="">
                  {formatMoney(item?.base_value ? Number(item?.base_value) : 0)}
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className=""></div>
          <div className="font-bold">{formatMoney(total ? total : 0)}</div>
        </div>
      </div>
    </Drawer>
  );
}
